import { Goerli } from "@usedapp/core";

export const ROUTER_ADDRESS = "0x0aa467419ffcfcd02deb9ddbbdb692f44e3c6cd2";

export const DAPP_CONFIG = {
  readOnlyChainId: Goerli.chainId,
  readOnlyUrls: {
    [Goerli.chainId]:
      "https://eth-goerli.g.alchemy.com/v2/ufHhQwFitrXJL6_XFhMNdqobltgKaUuT",
  },
};
